






























































import Vue from 'vue'
import Ref from 'vue'
import { TextInput, Button } from '@raksul/kamii-vue'
import ModalFullScreen from '@/common/components/ModalFullScreen.vue'
import
  ModalListing,
  { FullScreenModalTypes }
from '@/common/components/globalHeader/ModalListing.vue'
import { ProductCategory } from '@/model/productCategory'
import { APP_PATH_REGEX } from '@/common/constants'
import { BrandModel } from '@/common/types/brands'
import { getBrandsData } from '@/common/service'

import eventBus from '@/common/utils/eventBus'
import { APP_EVENTS } from '@/common/constants'
import { SEARCH_TRACKING_QUERY } from '@/common/utils/eventTracker'

export default Vue.extend({
  components: {
    TextInput,
    Button,
    ModalFullScreen,
    ModalListing
  },
  props: {
    productCategories: {
      type: Array as () => ProductCategory[],
      default: () => []
    }
  },
  data(): {
    keyword: string
    isSearchView: boolean
    searchBoxModalVisible: boolean
    currentModalType?: FullScreenModalTypes
    brands: readonly BrandModel[]
  } {
    return {
      keyword: '',
      isSearchView: false,
      searchBoxModalVisible: false,
      currentModalType: undefined,
      brands: []
    }
  },
  computed: {
    FullScreenModalTypes(): typeof FullScreenModalTypes {
      return FullScreenModalTypes
    }
  },
  async created() {
    const currentPath = window.location.pathname
    const { CATEGORY, SEARCH } = APP_PATH_REGEX
    this.isSearchView = CATEGORY.test(currentPath) || SEARCH.test(currentPath)
    if (this.isSearchView) {
      const parsedUrl = new URL(window.location.href)
      const keywordQuery = parsedUrl.searchParams.get('keyword') || ''
      this.keyword = keywordQuery
    }

    this.brands = await getBrandsData()
  },
  methods: {
    closeSearchBox() {
      this.searchBoxModalVisible = false
    },
    openSearchBox() {
      this.searchBoxModalVisible = true
      this.$nextTick(() => {
        ((this.$refs.innerSearchBox as Ref)
          .$refs.input as HTMLInputElement).focus()
      })
    },
    async getBrands() {
      if (this.brands.length) return
      this.brands = await getBrandsData()
    },
    openBrandsModal() {
      this.currentModalType = FullScreenModalTypes.BRANDS
      this.getBrands()
    },
    handleSearch() {
      if (this.isSearchView) {
        eventBus.$emit(APP_EVENTS.SEARCH_KEYWORD_APPLY, this.keyword)
        this.closeSearchBox()
      } else {
        window.location.href = `/search?keyword=${this.keyword}&${SEARCH_TRACKING_QUERY}=true`
      }
    }
  }
})
